import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Container, Input, InputGroup, InputGroupAddon, Row, Form } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../utils/Constants';
import { loadLoyaltyUsers } from '../../../actions';
import CustomTable from '../../common/CustomTable';
import PromoCodesModal from './PromoCodesModal';

class LoyaltyUsers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            advancedSearch: false,
            searchQuery: {
                restaurantId: this.props.restaurantId,
                page: 0,
                size: DEFAULT_PAGE_SIZE,
                customerId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: ''
            },
            promoCodesModal: false,
            userId: -1,
            userName: ''
        }
    }

    componentDidMount() {
        this.props.loadLoyaltyUsers(this.state.searchQuery);
    }

    handlePageChange = (pageNumber) => {
        this.setState({
            ...this.state,
            searchQuery: {
                ...this.state.searchQuery,
                page: (pageNumber - 1)
            }
        }, () => {
            this.props.loadLoyaltyUsers(this.state.searchQuery);
        });
    };

    changeState = ({ target }) => {
        this.setState({
            ...this.state,
            searchQuery: {
                ...this.state.searchQuery,
                [target.name]: target.value,
            }
        });
    };

    toggleSearch() {
        this.setState({
            ...this.state,
            advancedSearch: !this.state.advancedSearch,
            searchQuery: {
                restaurantId: this.props.restaurantId,
                page: 0,
                size: DEFAULT_PAGE_SIZE,
                customerId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: ''
            }
        });
    }

    clearSearch() {
        this.setState({
            ...this.state,
            searchQuery: {
                restaurantId: this.props.restaurantId,
                page: 0,
                size: DEFAULT_PAGE_SIZE,
                customerId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: ''
            }
        }, () => {
            this.props.loadLoyaltyUsers(this.state.searchQuery);
        });
    }

    search() {
        this.props.loadLoyaltyUsers(this.state.searchQuery);

        this.setState({
            currentPageNumber: 1
        });
    }

    keyPress(event) {
        if (event.keyCode === 13) { // this is Enter
            this.search();
        }
    }

    renderSimpleSearch() {
        const {
            flexEnd, inputGroupSearch, inputSearch, paddingLeftRight, rowMarginTop, simpleSearchPipe,
            inputGroupAddon, cursorPointer
        } = styles;
        const { customerName } = this.state.searchQuery;

        return (
            <div>
                <Row>
                    <Col xs="auto" sm={10}>
                        <Row>
                            <Col xs={4} style={paddingLeftRight}>
                                <InputGroup style={inputGroupSearch}>
                                    <Input
                                        type="text" name="customerName" id="brand"
                                        placeholder={i18n.t('screens:loyaltyScreen.name')} value={customerName}
                                        onChange={this.changeState}
                                        onKeyDown={this.keyPress.bind(this)} style={inputSearch} />
                                    <InputGroupAddon addonType="append" style={inputGroupAddon}>
                                        <div onClick={this.search.bind(this)} style={cursorPointer}><MaterialIcon
                                            icon="search" color="#0288D1" size={28} /></div>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={2} style={flexEnd}>
                        {/*<div>{this.renderAddBrand()}</div>*/}
                    </Col>
                </Row>
                <Row style={rowMarginTop}>
                    <Col xs={10}>
                        <Row>
                            <Col xs={4} style={flexEnd}>
                                <Button color="link"
                                    onClick={this.clearSearch.bind(this)}>{i18n.t('common:searchForms.clear')}</Button>
                                <span style={simpleSearchPipe}>|</span>
                                <Button color="link"
                                    onClick={this.toggleSearch.bind(this)}>{i18n.t('common:searchForms.advancedSearch')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderAdvancedSearch() {
        const {
            flexEnd, advancedSearchIcon, paddingLeftRight, searchButtonStyle,
            rowMarginTop, advancedSearchPipe
        } = styles;
        const { customerId, customerName, customerEmail, customerPhone } = this.state.searchQuery;

        return (
            <div>
                <Row>
                    <Col xs="auto" sm={10}>
                        <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                            <Row>
                                <Col style={paddingLeftRight}>
                                    <Input type="number" name="customerId" id="customerId"
                                        placeholder={i18n.t('screens:loyaltyScreen.userId')} value={customerId}
                                        onChange={this.changeState} />
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input type="text" name="customerName" id="customerName"
                                        placeholder={i18n.t('screens:loyaltyScreen.name')} value={customerName}
                                        onChange={this.changeState} />
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input type="text" name="customerPhone" id="customerPhone"
                                        placeholder={i18n.t('common:form.phone')} value={customerPhone}
                                        onChange={this.changeState} />
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input type="text" name="customerEmail" id="customerEmail"
                                        placeholder={i18n.t('common:form.email')} value={customerEmail}
                                        onChange={this.changeState} />
                                </Col>
                                <Col>
                                    <Button outline id="advanceSearchButton" color="primary" style={searchButtonStyle}
                                        onClick={this.search.bind(this)}>
                                        <span style={advancedSearchIcon}><MaterialIcon icon="search" color="#0288D1"
                                            size={28} /></span>{i18n.t('common:searchForms.search')}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row style={rowMarginTop}>
                    <Col xs={10} style={flexEnd}>
                        <Button color="link"
                            onClick={this.clearSearch.bind(this)}>{i18n.t('common:searchForms.clear')}</Button>
                        <span style={advancedSearchPipe}>|</span>
                        <Button color="link"
                            onClick={this.toggleSearch.bind(this)}>{i18n.t('common:searchForms.simpleSearch')}</Button>
                    </Col>
                </Row>
            </div>
        );
    }

    renderPromoCodesModal = (userId, userName) => {
        this.setState({
            ...this.state,
            promoCodesModal: true,
            userId: userId,
            userName: userName
        });
    };

    togglePromoCodesModal = () => {
        this.setState({
            promoCodesModal: !this.state.promoCodesModal
        });
    };

    render() {
        const { restaurantsHeading, containerStyle, flexEnd } = styles;

        return (
            <React.Fragment>
                {this.state.promoCodesModal &&
                    <PromoCodesModal
                        styles={styles}
                        modal={this.state.promoCodesModal}
                        userId={this.state.userId}
                        userName={this.state.userName}
                        restaurantId={this.props.restaurantId}
                        toggle={this.togglePromoCodesModal}
                    />
                }

                <Row>
                    <Col>
                        <div style={restaurantsHeading}>
                            <MaterialIcon
                                icon="group"
                                color="#000"
                                size={32} /> {i18n.t('screens:restaurantsMainContainer.users')}
                        </div>
                    </Col>
                </Row>
                <Container fluid style={containerStyle}>
                    {!this.state.advancedSearch ? this.renderAdvancedSearch() : this.renderSimpleSearch()}
                    {
                        this.props.loyaltyUsers.content.length !== 0 &&
                        <CustomTable
                            styles={styles}
                            tableName='loyaltyUsersTable'
                            tableData={this.props.loyaltyUsers.content}
                            renderUserCodes={this.renderPromoCodesModal}
                        />
                    }
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.loyaltyUsers.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.loyaltyUsers.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Container>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loyaltyUsers: state.loyaltyUsers
    }
};

export default connect(mapStateToProps, { loadLoyaltyUsers })(LoyaltyUsers);

let styles = {
    containerStyle: {
        width: '96%',
        marginTop: 20
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    inputGroupSearch: {
        border: '1px solid lightgray'
    },
    inputSearch: {
        border: 0
    },
    advancedSearchIcon: {
        float: 'left'
    },
    searchIcon: {
        marginTop: '-3px',
        position: 'absolute'
    },
    paddingLeftRight: {
        paddingLeft: 5,
        paddingRight: 5
    },
    searchButtonStyle: {
        width: '100%',
        verticalAlign: 'middle !important'
    },
    rowMarginTop: {
        marginBottom: 20
    },
    advancedSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    simpleSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    zeroPaddingRight: {
        paddingRight: 0
    },
    inputGroupAddon: {
        marginTop: '10px'
    },
    inputCheckbox: {
        marginLeft: '20px'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    posStyle: {
        paddingLeft: 5,
        paddingRight: 5
    },
    restaurantSummary: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    emailOverflow: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    restaurantsHeading: {
        borderBottom: "1px solid #dee2e6"
    },
    activeCode: {
        color: '#0288D1', 
        cursor: 'pointer', 
    },
};


// WEBPACK FOOTER //
// ./src/components/restaurants/loyalty/LoyaltyUsers.js